const ShipslandServiceList = [
    {
        id:1,
        name: 'Services',
        items: [ {
            id : 1,
            name: 'Logistics',
            items: [
                {
                    id:1,
                    name: 'Turkey-International',
                    items:[
                        {
                            id:1,
                            name:"TR-International Express"
                        },{
                            id:2,
                            name:"TR-International Eco (Small Package)"
                        },{
                            id:3,
                            name:"TR-EU (DDP)"
                        },{
                            id:4,
                            name:"TR-USA Less Container Load (DDP)"
                        }
                    ]
                },{
                    id:2,
                    name: 'China-International',
                    items:[
                        {
                            id:1,
                            name:"China-International Express",
                        },{
                            id:2,
                            name:"China-Turkey",
                            items:[
                                {
                                    id:1,
                                    name:"Small Package (DDP)"
                                },{
                                    id:2,
                                    name:"Sample (DDP)"
                                },{
                                    id:3,
                                    name:"Express (DDP)"
                                }
                            ]
                        },{
                            id:3,
                            name:"China-International Eco (Small Package)"
                        }
                    ]
                },{
                    id:3,
                    name: 'USA-International',
                    items:[
                        {
                            id:1,
                            name:"USA Domestic (LTL)"
                        },{
                            id:2,
                            name:"USA-Turkey (Small Package / DDP)"
                        },{
                            id:3,
                            name:"USA Domestic (Small Package)"
                        },{
                            id:4,
                            name:"USA International"
                        }
                    ]
                }
            ]
        },{
            id : 2,
            name: 'Fulfillment',
            items: [
                {
                    id:1,
                    name: 'USA Warehouse'
                },{
                    id:2,
                    name: 'China Warehouse'
                },{
                    id:3,
                    name: 'Germany Warehouse'
                },{
                    id:4,
                    name: 'Turkey Warehouse'
                }
            ]
        }]
    },{
        id:2,
        name: 'Prices'
    },{
        id:3,
        name: 'Contact Us'
    }
   
];

export default ShipslandServiceList;